export default class User {
  constructor(
    id,
    username,
    password,
    pin,
    firstName,
    lastName,
    waiverSigned,
    role,
    createdAt,
    slots,
    jokguTeam
  ) {
    this.id = id;
    this.username = username;
    this.password = password;
    this.pin = pin;
    this.firstName = firstName;
    this.lastName = lastName;
    this.waiverSigned = waiverSigned;
    this.role = role;
    this.createdAt = createdAt;
    this.slots = slots;
    this.jokguTeam = jokguTeam;
  }

  // You can add methods to work with the user data if needed
  updatePassword(newPassword) {
    this.password = newPassword;
  }

  updateWaiverStatus(status) {
    this.waiverSigned = status;
  }

  // Additional methods can be added as necessary for your business logic
}
